import features from 'Cloud/Application/Features';
import config from 'Cloud/config';
import { OLD_FORMAT_EXTS } from 'Cloud/ui/Viewer/viewer.constants';
import { addParams, addProtocol } from 'lib/urlUtils';
import { IS_PUBLIC, IS_STOCK } from 'reactApp/appHelpers/configHelpers';
import { isWopiEnabled, isWopiOldEnabled, expFormats } from 'reactApp/appHelpers/featuresHelpers';

const DOCUMENTS_ROOT = config.get('DOCUMENTS_ROOT');
const msViewer = config.get('MS_VIEWER');
const mailPadViewer = config.get('MAILPAD_VIEWER');
const r7Viewer = config.get('R7_VIEWER');
const myofficeViewer = config.get('MY_OFFICE_VIEWER');
const VIEWERS_CONFIG = config.get('VIEWERS') || [];

function isCanView(viewer, ext, isAttach, viewerExtLowerCase = false) {
    // WOPI версия мойОфиса умеет в старые форматы, amr версия - не умеет
    if (viewer === myofficeViewer && (OLD_FORMAT_EXTS.includes(ext?.toLowerCase())) && !(isWopiEnabled || isWopiOldEnabled)) {
        return false;
    }

    const extensions = viewer.view_extensions;
    const normalizedExt = viewerExtLowerCase && typeof ext === 'string' ? ext.toLowerCase() : ext;

    const canViewExt = Array.isArray(extensions) && extensions.length && extensions.includes(normalizedExt);
    const canViewExtExp = Array.isArray(expFormats) && expFormats.length && expFormats.includes(normalizedExt);
    const canViewAttach = !isAttach || Boolean(viewer.can_view_attach);

    return (canViewExt || canViewExtExp) && canViewAttach;
}

const viewers = {
    r7: {
        getViewUrl({ stockId, id, home }) {
            const viewUrl = (IS_STOCK ? stockId : id) || home;

            return Promise.resolve(`/${viewUrl}`);
        },
    },

    myoffice: {
        getViewUrl(item, wopiParams) {
            let viewUrl;
            if (wopiParams?.url) {
                viewUrl = addParams(wopiParams.url, {
                    title: 'title',
                    lang: 'ru-ru',
                    closebutton: 1,
                    revisionhistory: 1,
                });
            } else {
                viewUrl = (IS_STOCK ? item.stockId : item.id) || item.home;
                viewUrl = `/${viewUrl}`;
            }

            return Promise.resolve(viewUrl);
        },
    },

    mailpad: {
        getViewUrl(item) {
            const url = (IS_STOCK ? item.stockId : item.id) || item.home;
            const viewUrl = addProtocol(`${DOCUMENTS_ROOT}view/?src=${encodeURIComponent(url)}&r=${Math.random()}`);
            return Promise.resolve(viewUrl);
        },
    },

    office: {
        // eslint-disable-next-line no-unused-vars
        getViewUrl({ stockId, id, weblink, home, isStock }, wopiParams) {
            let viewUrl = msViewer.DOCUMENTS_ROOT.replace(/\/$/, '');

            if (isStock || IS_STOCK) {
                viewUrl += `/stock/${encodeURIComponent(stockId || id)}`;
            } else if (IS_PUBLIC) {
                viewUrl += `/public/${encodeURIComponent(weblink)}`;
            } else {
                viewUrl += `/home${encodeURIComponent(home || id)}`;
            }

            viewUrl = addProtocol(viewUrl);

            viewUrl = addParams(viewUrl, {
                from: 'cloud',
                access_token: wopiParams?.access_token,
                access_token_ttl: wopiParams?.access_token_ttl,
                url: wopiParams?.url ? encodeURIComponent(wopiParams?.url) : '',
                status: wopiParams?.status,
            });

            return Promise.resolve(viewUrl);
        },
    },
};

export const getViewerFor = function (ext, isAttach) {
    let type;
    let viewer;
    let wopi;

    const myOfficeViewerExtLowerCase = features.getFeature('myoffice-viewer-ext-lowercase');

    if (msViewer && isCanView(msViewer, ext, isAttach)) {
        type = 'office';
    } else if (mailPadViewer && isCanView(mailPadViewer, ext, isAttach)) {
        type = 'mailpad';
    } else if (r7Viewer && isCanView(r7Viewer, ext, isAttach)) {
        type = 'r7';
    } else if (myofficeViewer && isCanView(myofficeViewer, ext, isAttach, myOfficeViewerExtLowerCase)) {
        type = 'myoffice';
    } else {
        type = null;
    }

    if (type && viewers[type]) {
        viewer = viewers[type];
        wopi = VIEWERS_CONFIG.find((editor) => editor.id === type)?.wopi;
    }

    return {
        ...viewer,
        type,
        wopi,
        isMsViewer: type === 'office',
        isMailpad: type === 'mailpad',
        isR7: type === 'r7',
        isMyOffice: type === 'myoffice',
    };
};
